'use client';
import React from 'react';
import { ProductMetadata as SharedProductMetadata } from '@launchstore/shared-puck';
import type { ProductMetadataProps } from '@launchstore/shared-puck';
import { useProduct } from '@/lib/hooks/useProduct';
import type { ProductData } from '@launchstore/shared-puck';

const toProductData = (p: any): ProductData | null => {
  if (!p) return null;
  return {
    id: p.id, title: p.title, handle: p.handle, description: p.description,
    material: p.material, weight: p.weight, length: p.length, width: p.width, height: p.height,
    origin_country: p.origin_country, metadata: p.metadata,
    variants: (p.variants || []).map((v: any) => ({
      id: v.id, sku: v.sku, weight: v.weight, length: v.length, width: v.width, height: v.height,
    })),
  };
};

const SharedProductMetadataRender = (SharedProductMetadata as any).render;

const ProductMetadataImpl: React.FC<ProductMetadataProps> = (props: any) => {
  const { product } = useProduct();
  return <SharedProductMetadataRender {...(props as any)} product={toProductData(product)} />;
};

export const ProductMetadata: any = { ...SharedProductMetadata, render: (props: any) => <ProductMetadataImpl {...props} /> };
export default ProductMetadata;
